export default "__VITE_ASSET__BQ5osJ2t__"